import React, {Component} from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {withTranslate} from "react-redux-multilingual";
import {TbMaximize} from 'react-icons/tb';
import Picture from "../../cpr/Picture";
import './gallerry.scss';

// Same photos as before (general/6, 7, 2, 5, 8, 1), served from the optimised set.
// Order matches the grid: portrait interiors sit in the tall slots 3 and 5.
const PHOTOS = ['courtyard-lounge', 'courtyard-pool', 'elevator-hall', 'courtyard-pavilion', 'corridor', 'terrace'];
const largeSrc = (name) => {
    const big = ['corridor', 'elevator-hall'].includes(name) ? 640 : 1920;
    return `${process.env.PUBLIC_URL}/assets/images/cpr/${name}-${big}.jpg`;
};

class GallerrySection extends Component {
    state = {
        isOpen: false,
        index: 0,
    }

    open(e, index) {
        e.preventDefault()
        this.setState({isOpen: true, index})
    }

    render() {
        const {translate} = this.props;
        const {index} = this.state;
        const count = PHOTOS.length;

        return (
            <section className="cpr-section cpr-gallery" aria-labelledby="cpr-gallery-title">
                <div className="cpr-container">
                    <h2 id="cpr-gallery-title" className="cpr-h2 cpr-gallery__title">{translate('gallery')}</h2>
                    <ul className="cpr-gallery__grid">
                        {PHOTOS.map((name, i) => (
                            <li key={name} className={`cpr-gallery__item cpr-gallery__item--${i + 1}`}>
                                <a href={largeSrc(name)} className="cpr-card" onClick={(e) => this.open(e, i)}>
                                    <div className="cpr-media">
                                        <Picture name={name} alt="" sizes="(min-width: 1024px) 33vw, 50vw"/>
                                        <span className="cpr-gallery__zoom" aria-hidden="true"><TbMaximize/></span>
                                    </div>
                                    <span className="cpr-visually-hidden">{translate('view_photo')} {i + 1}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                {
                    this.state.isOpen &&
                    <Lightbox
                        mainSrc={largeSrc(PHOTOS[index])}
                        nextSrc={largeSrc(PHOTOS[(index + 1) % count])}
                        prevSrc={largeSrc(PHOTOS[(index + count - 1) % count])}
                        onMovePrevRequest={() => this.setState({index: (index + count - 1) % count})}
                        onMoveNextRequest={() => this.setState({index: (index + 1) % count})}
                        onCloseRequest={() => this.setState({isOpen: false})}/>
                }
            </section>
        )
    }
}
export default withTranslate(GallerrySection);
